import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MonthYearFieldComponent } from './month-year-field.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [MonthYearFieldComponent],
  imports: [CommonModule, MatDatepickerModule, MatNativeDateModule, MatInputModule, ReactiveFormsModule],
  exports: [MonthYearFieldComponent],
})
export class MonthYearFieldModule {}
